import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './config/store';
import { Root } from './root/root';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import {appHistory} from "app-history";
import { CustomRouter } from 'shared/util/custom-router';
import 'shared/util/axios-retry';

if (process.env.NODE_ENV === 'production') console.log = () => {};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <Provider store={store}>
      <CustomRouter history={appHistory}>
        <Root />
      </CustomRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
